"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Copyright 2024, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const highcharts_1 = __importDefault(require("highcharts"));
const highcharts_react_official_1 = __importDefault(require("highcharts-react-official"));
const max_1 = __importDefault(require("lodash/max"));
const HashLoader_1 = __importDefault(require("react-spinners/HashLoader"));
const StartedAndCompletedInterviewsByDay = () => {
    const [data, setData] = react_1.default.useState({
        started: [],
        completed: [],
        dates: [],
        startedCount: undefined,
        completedCount: undefined
    });
    const { t } = (0, react_i18next_1.useTranslation)();
    const reactHighchartsRef = (0, react_1.useRef)(null);
    react_1.default.useEffect(() => {
        fetch('/api/admin/data/widgets/started-and-completed-interviews-by-day', {
            method: 'POST',
            body: JSON.stringify({
                refreshCache: false
            }),
            credentials: 'include',
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then((response) => {
            if (response.status === 200) {
                response
                    .json()
                    .then((jsonData) => {
                    setData(jsonData);
                })
                    .catch((err) => {
                    console.log('Error converting data to json.', err);
                });
            }
        })
            .catch((err) => {
            console.log('Error fetching data.', err);
        });
    }, []);
    if (!(data.started.length > 0)) {
        return react_1.default.createElement(HashLoader_1.default, { size: '30px', color: '#aaaaaa', loading: true });
    }
    // generate cumulative counts arrays:
    const cumulativeStartedData = [];
    data.started.reduce((cumulativeCount, value, i) => {
        return (cumulativeStartedData[i] = cumulativeCount + value);
    }, 0);
    const cumulativeCompletedData = [];
    data.completed.reduce((cumulativeCount, value, i) => {
        return (cumulativeCompletedData[i] = cumulativeCount + value);
    }, 0);
    const dataMax = (0, max_1.default)(data.started) || 0;
    const cumulativeDataMax = (0, max_1.default)(cumulativeStartedData) || 0;
    const chartOptions = {
        isPureConfig: true, // don't refresh if config did not change
        chart: {
            type: 'column',
            style: {
                fontFamily: '"Lato", Helvetica, Arial, sans-serif;',
                fontWeight: 100
            }
        },
        title: {
            text: t('admin:StartedAndCompletedInterviewsPerDay')
        },
        subtitle: {
            text: ''
        },
        xAxis: {
            categories: data.dates,
            lineColor: 'transparent',
            minorTickLength: 0,
            tickLength: 0,
            gridLineWidth: 0,
            minorGridLineWidth: 0
        },
        yAxis: [
            {
                title: {
                    text: t('admin:NumberOfInterviews')
                },
                gridZIndex: 10,
                alignTicks: false,
                gridLineColor: 'rgba(255,255,255,0.4)',
                tickInterval: Math.ceil(dataMax / 10), // here we need to get the max
                max: dataMax
            },
            {
                title: {
                    text: t('admin:CumulativeNumberOfInterviews')
                },
                alignTicks: false,
                gridLineWidth: 0,
                max: cumulativeDataMax,
                opposite: true
            }
        ],
        legend: {
            enabled: true
        },
        plotOptions: {
            series: {
                pointPadding: 0,
                borderWidth: 1,
                groupPadding: 0.1,
                dataLabels: {
                    enabled: false,
                    format: '{point.y:.0f}',
                    style: {
                        color: 'rgba(0,0,0,0.5)'
                    }
                }
            }
        },
        tooltip: {
            headerFormat: '<span style="font-size: 11px">{series.name}</span><br />',
            pointFormat: '<span style="color: {point.color}">{point.name}</span> <strong>{point.y:.0f}</strong><br />'
        },
        series: [
            {
                name: t('admin:StartedFem'),
                color: 'rgba(164, 219, 79, 1)',
                data: data.started,
                type: 'column'
            },
            {
                name: t('admin:CompletedFem'),
                color: 'rgba(66, 134, 38, 1)',
                data: data.completed,
                type: 'column'
            },
            {
                name: t('admin:StartedFem'),
                color: 'rgba(164, 219, 79, 0.5)',
                data: cumulativeStartedData,
                yAxis: 1,
                type: 'line',
                zIndex: 20,
                marker: { enabled: false },
                lineWidth: 1
            },
            {
                name: t('admin:CompletedFem'),
                color: 'rgba(66, 134, 38, 0.5)',
                data: cumulativeCompletedData,
                yAxis: 1,
                type: 'line',
                zIndex: 20,
                marker: { enabled: false },
                lineWidth: 1
            }
        ]
    };
    const completionRate = data.startedCount !== undefined && data.completedCount !== undefined && data.startedCount > 0
        ? data.completedCount / data.startedCount
        : null;
    return (react_1.default.createElement("div", { className: "admin-widget-container", style: { width: `${Math.min(1600, Math.max(250, data.dates.length * 30 + 150))}px` } },
        react_1.default.createElement(highcharts_react_official_1.default, { highcharts: highcharts_1.default, options: chartOptions, ref: reactHighchartsRef }),
        react_1.default.createElement("p", { className: "no-bottom-margin" },
            data.startedCount && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("span", null,
                    t('admin:StartedFem'),
                    " : "),
                react_1.default.createElement("strong", null, data.startedCount))),
            data.completedCount && (react_1.default.createElement(react_1.default.Fragment, null,
                ' ',
                "\u2022 ",
                react_1.default.createElement("span", null,
                    t('admin:CompletedFem'),
                    " : "),
                react_1.default.createElement("strong", null, data.completedCount),
                completionRate ? react_1.default.createElement("span", null,
                    " (",
                    (completionRate * 100).toFixed(1),
                    "%)") : '')))));
};
exports.default = StartedAndCompletedInterviewsByDay;
//# sourceMappingURL=StartedAndCompletedInterviewByDay.js.map